/**
 * Story 027.007: the chat navigation tree's saved routines — the SAME hook and IDs as My routines
 * (PersonalRoutinesList), compact. Unavailable says so; empty shows nothing to open.
 */
import { Link } from "react-router-dom";
import { usePersonalRoutines } from "../../hooks/usePersonalRoutines";
import { PersonalRoutinesMore } from "./PersonalRoutinesMore";
import { setupLabel, verificationLabel } from "./personal-routine-labels";

export function PersonalRoutinesNavTree({ onNavigate }: { onNavigate?: () => void }) {
  const list = usePersonalRoutines("mine");
  const { items, status } = list;
  if (status === "loading") {
    return null;
  }
  if (status !== "ready" && status !== "empty") {
    return (
      <p role="status" className="ml-6 px-3 py-1 text-xs text-muted-foreground">
        Saved routines unavailable
      </p>
    );
  }
  if (status === "empty") {
    return <p className="ml-6 px-3 py-1 text-xs text-muted-foreground">No saved routines yet</p>;
  }
  return (
    <>
      <ul
        aria-label="Your saved routines"
        className="mt-0.5 mb-1 ml-6 space-y-0.5 border-l border-border/60 pl-3"
      >
        {items.map((item) =>
          item.useId ? (
            <li key={item.useId} data-use-id={item.useId} data-routine-id={item.routineId}>
              <Link
                to={`/routines/u/${encodeURIComponent(item.useId)}`}
                onClick={onNavigate}
                className="block rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus-visible:ring-2"
              >
                <span className="block truncate">{item.name}</span>
                <span className="block text-[10px]">
                  {setupLabel(item)} · {verificationLabel(item.version.verificationStatus)}
                </span>
              </Link>
            </li>
          ) : null,
        )}
      </ul>
      <div className="ml-6 pl-3">
        <PersonalRoutinesMore list={list} compact />
      </div>
    </>
  );
}
